import { useFormContext } from "react-hook-form"
import { FieldError } from "@motleyhand/design"
import getOwnMessage from "./getOwnMessage"

type Props = {
  path?: string
  className?: string
}

export default function FormError({
  path = "root.formError",
  className = "mb-4",
}: Props) {
  const {
    formState: { errors },
  } = useFormContext()
  const message = getOwnMessage(errors, path)

  return !message ? null : (
    <FieldError className={className}>{message}</FieldError>
  )
}
